let wind_data = [
    {
        type: '공용 라이프스타일',
        name: '2 Layer 쉘 자켓',
        price: '199,000원',
        imgUrl: '/img/now1.jpg'
    },
    {
        type: '공용 라이프스타일',
        name: '컬러블럭 스트레치 바람막이',
        price: '159,000원',
        imgUrl: '/img/now2.jpg'
    },
    {
        type: '공용 라이프스타일',
        name: '컬러블럭 스트레치 바람막이',
        price: '159,000원',
        imgUrl: '/img/now3.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '컬러블럭 스트레치 후드 바람막이',
        price: '169,000원',
        imgUrl: '/img/now4.jpg'
    },
    {
        type: '여성 라이프스타일',
        name: '후드 글로시 바람막이',
        price: '169,000원',
        imgUrl: '/img/now5.jpg'
    },
    {
        type: '여성 컴포트핏 라이프스타일',
        name: '재귀반사 바람막이',
        price: '149,000원',
        imgUrl: '/img/now6.jpg'
    },
    {
        type: '공용 라이프스타일',
        name: 'Fila athletics 아노락',
        price: '109,000원',
        imgUrl: '/img/now7.jpg'
    },
    {
        type: '공용 테니스',
        name: 'Fila tennis 블럭 자켓',
        price: '129,000원',
        imgUrl: '/img/now8.jpg'
    }
]


export default wind_data;